import { useEventData } from "hooks/useEvent"

import EventListItemSkeleton from "./EventListItemSkeleton"
import EventListItem from "./EventListItem"
import { CollectionFromIframe } from "meta/pages/collection"

interface Props {
  eventCode: string
}

const EventListItemContainer: React.FC<Props & CollectionFromIframe> = (props) => {
  const { eventCode, fromIframe, toggleContent } = props

  const eventData = useEventData({ idOrCodeUrl: eventCode })

  if (!eventData) {
    return <EventListItemSkeleton />
  }

  return <EventListItem data={eventData} fromIframe={fromIframe} toggleContent={toggleContent}  />
}

export default EventListItemContainer